<script>

    import PreviewElement from "./PreviewElement";
    import ButtonWrapperElement from "../../components/pagesbuilder/elements/ButtonWrapperElement";

    export default {
        name: "PreviewButtonWrapperElement",
        mixins: [
            PreviewElement,
            ButtonWrapperElement
        ]
    }
</script>
